import Vue from 'vue'
import Toasted from 'vue-toasted'

import * as ff  from "@/config"

Vue.use(Toasted)

export default {

  data() {
    return {
      apiUrl: ff.apiUrl
    }
  },

  methods: {
    ERROR_TOAST_MSG (msg) {
      Vue.toasted.show(msg, {
        type: 'error',
        icon: '✘'
      }).goAway(4000)
    },
    SUCCESS_TOAST_MSG (msg) {
      Vue.toasted.show(msg, {
        type: 'success',
        icon: '✔️'
      }).goAway(4000)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/index.js